import { render } from "./QuestionFormBuilder.vue?vue&type=template&id=297e0d7a&scoped=true"
import script from "./QuestionFormBuilder.vue?vue&type=script&lang=js"
export * from "./QuestionFormBuilder.vue?vue&type=script&lang=js"

import "./QuestionFormBuilder.vue?vue&type=style&index=0&id=297e0d7a&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.23_vue@3.5.23_typescript@5.4.2__webpack@5.102.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-297e0d7a"]])

export default __exports__